import { createActions } from 'redux-actions'

export const { selectWorkspace, initState, injectState } = createActions({
  SELECT_WORKSPACE: workspace => ({ workspace }),
  INIT_STATE: (workspaceId, endpoint) => ({ workspaceId, endpoint }),
  INJECT_STATE: state => ({ state }),
})



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/state/workspace/actions.ts